/* eslint-disable import/prefer-default-export, @typescript-eslint/no-unsafe-assignment */
import { BiCommentDots, BiSearch } from 'react-icons/bi';
import { FaHandshake } from 'react-icons/fa';
import { LiaDiceSolid } from 'react-icons/lia';
import { IoSettingsSharp } from 'react-icons/io5';
import { Module } from 'src/access';
import { IMenuItem } from 'src/components/MenuItem';
import {
  DashboardIcon,
} from 'src/icons';

const menu: IMenuItem[] = [
  {
    name: 'Dashboard',
    Icon: DashboardIcon,
    href: '/dashboard',
    modules: [Module.ATS_DASHBOARD],
  },
  {
    name: 'Job Requisition',
    Icon: DashboardIcon,
    href: '/job-requisition',
    module: Module.ATS_RECRUITER,
  },
  {
    name: 'Interviews',
    Icon: BiCommentDots,
    href: '/interviews',
    module: Module.ATS_RECRUITER,
  },
  {
    name: 'Talent pool',
    Icon: BiSearch,
    href: '/talent-pool',
    modules: [
      Module.TALENT_POOL,
    ],
  },
  {
    name: 'Dice',
    Icon: LiaDiceSolid,
    href: '/dice/search',
    modules: [
      Module.DICE_SEARCH,
      Module.DICE_HISTORY,
      Module.DICE_DASHBOARD,
      Module.DICE_JOBS,
      Module.DICE_ATS_PROFILE_VIEW,
    ],
  },
  {
    name: 'Vendors',
    Icon: FaHandshake,
    href: '/vendors',
    module: Module.VENDORS,
  },
  {
    name: 'Settings',
    Icon: IoSettingsSharp,
    href: '/settings',
    module: Module.ATS_RECRUITER,
  },
];

export {
  menu,
};
